"use client";

import React from "react";
import { Dialog, Modal, XIcon } from "staysure-component-library";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";

type ReferFriendModalProps = {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
};

function ReferFriendModal({
  isOpen,
  setIsOpen,
}: Readonly<ReferFriendModalProps>) {
  const { current } = useWizard();

  return (
    <Modal
      onOpenChange={(e: boolean) => setIsOpen(e)}
      underlayStyles={{ zIndex: 200 }}
      isOpen={isOpen}
      modalStyles={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="!z-[200] bg-surface-neutral-option-1 w-[75dvw] md:w-[65dvw] tablet:w-[55dvw] smallDesktop:w-[80dvw] lg:w-[55dvw] max-w-[870px] items-center justify-center  relative rounded-radius-lg"
      uderlayClassName="z-[200] bg-interactive-overlay-default"
    >
      <Dialog className=" relative" data-testid="refer-friend-dialog">
        <button
          id="refer-friend-modal-close-button"
          type="button"
          className="opacity-0 absolute right-2 top-2 w-10 h-10"
          onClick={() => {
            setIsOpen(false);
          }}
          aria-label="close modal"
        >
          <XIcon stroke="#522367" />
        </button>
        <div className="flex-col ">
          <iframe
            src={current.brandSpecificParams?.referFriendUrl as string}
            className="w-full min-h-[600px] md:min-h-[700px] lg:min-h-[600px]"
            title="Embedded Page"
            scrolling="no"
          />
        </div>
      </Dialog>
    </Modal>
  );
}

export default ReferFriendModal;
